import ShapesTab from "@/components/brandkit/ShapesTab";
import LibraryTab from "@/components/brandkit/LibraryTab";

/**
 * Brand Assets — merges the former Shapes and Library (photography) tabs
 * into a single home for the brand's non-type graphic + photographic assets.
 */
export default function AssetsTab({ brandId, canManage }) {
  return (
    <div data-testid="brand-kit-assets-tab" className="space-y-12">
      <section>
        <h2 className="font-serif text-2xl">Shapes &amp; graphic devices</h2>
        <p className="text-sm text-[#6B6358] mt-1 mb-5 max-w-2xl">
          Reusable brand shapes, seals, and graphic devices (PDF, SVG or image).
        </p>
        <ShapesTab brandId={brandId} canManage={canManage} />
      </section>

      <section className="pt-8 border-t border-[#1A1F2C]/10">
        <h2 className="font-serif text-2xl">Photography library</h2>
        <p className="text-sm text-[#6B6358] mt-1 mb-5 max-w-2xl">
          Brand-approved photography, tagged by subject. The AI draws from this
          pool when a project needs an image and the Content Library has none.
        </p>
        <LibraryTab brandId={brandId} canManage={canManage} />
      </section>
    </div>
  );
}
